import React from 'react';

import StarsButton from '@swf/components/StarsButton/StarsButton';
import useOpenActiveTable from '@swf/core/hooks/useOpenActiveTable';

import { TXTCLI_Active_Table } from './ActiveTableButton.messages.json';
import styles from './ActiveTableButton.scss';
import ActiveTableIcon from './assets/active-table.svg';

const ActiveTableButton: React.FC = () => {
  const { openActiveTable } = useOpenActiveTable();

  return (
    <StarsButton
      className={styles.activeTableButton}
      icon={<ActiveTableIcon />}
      type="button"
      onClick={() => {
        openActiveTable();
      }}
      translation={TXTCLI_Active_Table}
    />
  );
};
export default ActiveTableButton;
